import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

interface UpdateObj {
  addDL: string;
  spacerColor?: string;
  liteConfig?: string;
  diffSideliteSdl?: boolean;
}

function useLiteSelection() {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorType = useStore((state) => state.quote.doorType);

  const materialChoice = useStore((state) => state.quote.material);
  const stiles = useStore((state) => state.quote.stileCategory);

  const addDL = useStore((state) => state.quote.addDL);
  const liteConfig = useStore((state) => state.quote.liteConfig);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const sdlExteriorShape = useStore((state) => state.quote.sdlExteriorShape);

  const handleLitesClick = (label: string) => {
    const checked = label === liteConfig;

    if (checked) {
      addToQuote({ liteConfig: "", sdlExteriorShape: "" });
    } else {
      if (findRequired("Divided Lites Size")) {
        removeRequired("Divided Lites Size");
      }
      addToQuote({ liteConfig: label, sdlExteriorShape: "" });
    }

    if (findRequired("SDL Exterior Shape")) {
      removeRequired("SDL Exterior Shape");
    }
  };

  const handleClick = (label: string) => {
    const checked = label === addDL;

    if (checked) {
      addToQuote(
        {
          liteConfig: "",
          addDL: "",
          sdlExteriorShape: "",
        },
        "addDL",
      );

      if (findRequired("SDL Exterior Shape")) {
        removeRequired("SDL Exterior Shape");
      }
    } else {
      let update: UpdateObj = { addDL: label };

      if (label === "Add SDL") {
        update["spacerColor"] = "Black";
        if (findRequired("IG Spacer Color")) removeRequired("IG Spacer Color");
      }

      if (label === "Add TDL") update["liteConfig"] = '1 3/4"';

      if (doorType === "Pivot" && label === "Add Intermediate Rail") {
        const railSize = stiles === "Traditional" ? '5 1/4"' : '2 1/2"';
        update["liteConfig"] = railSize;
        update["diffSideliteSdl"] = false;
      }

      addToQuote(update);
    }
  };

  const handleSDLExteriorShapeClick = (label: string) => {
    const checked = label === sdlExteriorShape;

    if (checked) {
      addToQuote({ sdlExteriorShape: "" });
    } else {
      addToQuote({ sdlExteriorShape: label });
      if (findRequired("SDL Exterior Shape")) {
        removeRequired("SDL Exterior Shape");
      }
    }
  };

  return {
    handleClick,
    handleLitesClick,
    handleSDLExteriorShapeClick,
    materialChoice,
    doorType,
    liteConfig,
    sdlExteriorShape,
    addDL,
  };
}

export default useLiteSelection;
